import { render, staticRenderFns } from "./DutyStation.vue?vue&type=template&id=60973d02&"
import script from "./DutyStation.vue?vue&type=script&lang=js&"
export * from "./DutyStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports